
    import Vue from 'vue';
    import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
    import HeadingWave from "@/features/shared/components/HeadingWave.vue";
    import Component from "vue-class-component";
    import {isNullOrWhiteSpace} from "@/extensions/string.helpers";
    import {ResultError, SeafarersClient} from "@/api-client";
    import LoadingSpinner from "@/components/LoadingSpinner.vue";
    import Loader from "@/features/shared/components/Loader";
    import toasts from "@/components/Toasts";

    @Component({
        components: {
            SectionPageHeading,
            HeadingWave,
            LoadingSpinner
        },
    })
    export default class AddSeafarerWithPersonalCode extends Vue {
        personalCode = "";
        
        validationErrors = ResultError.createEmpty();
        loader = new Loader();
        
        get isPersonalCodeInCorrectFormat(){
            return !isNullOrWhiteSpace(this.personalCode) && new RegExp("^[0-9]{11}$").test(this.personalCode);
        }
        
        addSeafarer(){
            if(!this.isPersonalCodeInCorrectFormat) return;
            new SeafarersClient().setLoader(this.loader).addWithPersonalCode(this.personalCode)
                .then(result => {
                    toasts.success(this.$ls.Global_Toast_AddSuccess);
                    this.$router.push({name: "person-profile", params:{seafarerId: result.id}})
                }).catch(error => this.setValidationErrors(error, this.$ls.Global_Toast_FormAddFailure));
        }
    }
